import React from 'react'
import { Table, Caption, Thead, Tr, Th, Tbody, Td } from '@patternfly/react-table'

export function InfraTable(props: {
  finalInfraDeps: { name: string; branch: string }[],
  branchMapping: Record<string, string>,
  deploymentBranch: string
}) {
  const { finalInfraDeps, branchMapping, deploymentBranch } = props

  return (
    <Table aria-label="Infrastructure Dependencies" gridBreakPoint="grid-lg">
      <Caption>Infrastructure dependencies (using deployment branch)</Caption>
      <Thead>
        <Tr>
          <Th>Infrastructure</Th>
          <Th>Deployment Branch</Th>
        </Tr>
      </Thead>
      <Tbody>
        {finalInfraDeps.map((dep) => {
          const branchValue = branchMapping[dep.name] || deploymentBranch
          return (
            <Tr key={dep.name}>
              <Td dataLabel="Infrastructure">{dep.name}</Td>
              <Td dataLabel="Deployment Branch">{branchValue}</Td>
            </Tr>
          )
        })}
      </Tbody>
    </Table>
  )
}


